import * as p from "react";
import { useLayoutEffect as Kn } from "react";
import { jsxs as Hn, jsx as he, Fragment as Ir } from "react/jsx-runtime";
import * as zn from "react-dom";
function At() {
  return typeof window < "u";
}
function ke(e) {
  return tn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ae(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ee(e) {
  var t;
  return (t = (tn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tn(e) {
  return At() ? e instanceof Node || e instanceof ae(e).Node : !1;
}
function Y(e) {
  return At() ? e instanceof Element || e instanceof ae(e).Element : !1;
}
function te(e) {
  return At() ? e instanceof HTMLElement || e instanceof ae(e).HTMLElement : !1;
}
function vt(e) {
  return !At() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ae(e).ShadowRoot;
}
function Ot(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function Cr(e) {
  return /^(table|td|th)$/.test(ke(e));
}
function Mt(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Tr = /transform|translate|scale|rotate|perspective|filter/, Sr = /paint|layout|strict|content/, Fe = (e) => !!e && e !== "none";
let _t;
function nn(e) {
  const t = Y(e) ? ve(e) : e;
  return Fe(t.transform) || Fe(t.translate) || Fe(t.scale) || Fe(t.rotate) || Fe(t.perspective) || !Pt() && (Fe(t.backdropFilter) || Fe(t.filter)) || Tr.test(t.willChange || "") || Sr.test(t.contain || "");
}
function Ar(e) {
  let t = Pe(e);
  for (; te(t) && !Oe(t); ) {
    if (nn(t))
      return t;
    if (Mt(t))
      return null;
    t = Pe(t);
  }
  return null;
}
function Pt() {
  return _t == null && (_t = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), _t;
}
function Oe(e) {
  return /^(html|body|#document)$/.test(ke(e));
}
function ve(e) {
  return ae(e).getComputedStyle(e);
}
function kt(e) {
  return Y(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Pe(e) {
  if (ke(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    vt(e) && e.host || // Fallback.
    Ee(e)
  );
  return vt(t) ? t.host : t;
}
function Un(e) {
  const t = Pe(e);
  return Oe(t) ? (e.ownerDocument || e).body : te(t) && Ot(t) ? t : Un(t);
}
function Me(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Un(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = ae(o);
  if (s) {
    const c = Xt(i);
    return t.concat(i, i.visualViewport || [], Ot(o) ? o : [], c && n ? Me(c) : []);
  } else
    return t.concat(o, Me(o, [], n));
}
function Xt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const ze = Math.min, xe = Math.max, bt = Math.round, Be = Math.floor, Re = (e) => ({
  x: e,
  y: e
}), Or = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Mr(e, t, n) {
  return xe(e, ze(t, n));
}
function Qe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function We(e) {
  return e.split("-")[0];
}
function et(e) {
  return e.split("-")[1];
}
function qn(e) {
  return e === "x" ? "y" : "x";
}
function jn(e) {
  return e === "y" ? "height" : "width";
}
function ye(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Gn(e) {
  return qn(ye(e));
}
function Pr(e, t, n) {
  n === void 0 && (n = !1);
  const r = et(e), o = Gn(e), s = jn(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = wt(i)), [i, wt(i)];
}
function kr(e) {
  const t = wt(e);
  return [Yt(e), t, Yt(t)];
}
function Yt(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const fn = ["left", "right"], dn = ["right", "left"], Dr = ["top", "bottom"], Fr = ["bottom", "top"];
function Lr(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? dn : fn : t ? fn : dn;
    case "left":
    case "right":
      return t ? Dr : Fr;
    default:
      return [];
  }
}
function Nr(e, t, n, r) {
  const o = et(e);
  let s = Lr(We(e), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), t && (s = s.concat(s.map(Yt)))), s;
}
function wt(e) {
  const t = We(e);
  return Or[t] + e.slice(t.length);
}
function Wr(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function _r(e) {
  return typeof e != "number" ? Wr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function yt(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
var Vr = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], xt = /* @__PURE__ */ Vr.join(","), Xn = typeof Element > "u", Ue = Xn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Rt = !Xn && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Et = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), s = o === "" || o === "true", i = s || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : Et(t.parentNode));
  return i;
}, $r = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Yn = function(t, n, r) {
  if (Et(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(xt));
  return n && Ue.call(t, xt) && o.unshift(t), o = o.filter(r), o;
}, It = function(t, n, r) {
  for (var o = [], s = Array.from(t); s.length; ) {
    var i = s.shift();
    if (!Et(i, !1))
      if (i.tagName === "SLOT") {
        var c = i.assignedElements(), a = c.length ? c : i.children, l = It(a, !0, r);
        r.flatten ? o.push.apply(o, l) : o.push({
          scopeParent: i,
          candidates: l
        });
      } else {
        var u = Ue.call(i, xt);
        u && r.filter(i) && (n || !t.includes(i)) && o.push(i);
        var d = i.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(i), f = !Et(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(i));
        if (d && f) {
          var m = It(d === !0 ? i.children : d.children, !0, r);
          r.flatten ? o.push.apply(o, m) : o.push({
            scopeParent: i,
            candidates: m
          });
        } else
          s.unshift.apply(s, i.children);
      }
  }
  return o;
}, Zn = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Jn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || $r(t)) && !Zn(t) ? 0 : t.tabIndex;
}, Br = function(t, n) {
  var r = Jn(t);
  return r < 0 && n && !Zn(t) ? 0 : r;
}, Kr = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Qn = function(t) {
  return t.tagName === "INPUT";
}, Hr = function(t) {
  return Qn(t) && t.type === "hidden";
}, zr = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Ur = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, qr = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Rt(t), r = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var s = Ur(o, t.form);
  return !s || s === t;
}, jr = function(t) {
  return Qn(t) && t.type === "radio";
}, Gr = function(t) {
  return jr(t) && !qr(t);
}, Xr = function(t) {
  var n, r = t && Rt(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, s = !1;
  if (r && r !== t) {
    var i, c, a;
    for (s = !!((i = o) !== null && i !== void 0 && (c = i.ownerDocument) !== null && c !== void 0 && c.contains(o) || t != null && (a = t.ownerDocument) !== null && a !== void 0 && a.contains(t)); !s && o; ) {
      var l, u, d;
      r = Rt(o), o = (l = r) === null || l === void 0 ? void 0 : l.host, s = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return s;
}, gn = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Yr = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var s = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !s;
  }
  var i = getComputedStyle(t), c = i.visibility;
  if (c === "hidden" || c === "collapse")
    return !0;
  var a = Ue.call(t, "details>summary:first-of-type"), l = a ? t.parentElement : t;
  if (Ue.call(l, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var u = t; t; ) {
        var d = t.parentElement, f = Rt(t);
        if (d && !d.shadowRoot && o(d) === !0)
          return gn(t);
        t.assignedSlot ? t = t.assignedSlot : !d && f !== t.ownerDocument ? t = f.host : t = d;
      }
      t = u;
    }
    if (Xr(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return gn(t);
  return !1;
}, Zr = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Ue.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Zt = function(t, n) {
  return !(n.disabled || Hr(n) || Yr(n, t) || // For a details element with a summary, the summary element gets the focus
  zr(n) || Zr(n));
}, Jt = function(t, n) {
  return !(Gr(n) || Jn(n) < 0 || !Zt(t, n));
}, Jr = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, er = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, s) {
    var i = !!o.scopeParent, c = i ? o.scopeParent : o, a = Br(c, i), l = i ? er(o.candidates) : c;
    a === 0 ? i ? n.push.apply(n, l) : n.push(c) : r.push({
      documentOrder: s,
      tabIndex: a,
      item: o,
      isScope: i,
      content: l
    });
  }), r.sort(Kr).reduce(function(o, s) {
    return s.isScope ? o.push.apply(o, s.content) : o.push(s.content), o;
  }, []).concat(n);
}, Dt = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = It([t], n.includeContainer, {
    filter: Jt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Jr
  }) : r = Yn(t, n.includeContainer, Jt.bind(null, n)), er(r);
}, Qr = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = It([t], n.includeContainer, {
    filter: Zt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Yn(t, n.includeContainer, Zt.bind(null, n)), r;
}, tr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ue.call(t, xt) === !1 ? !1 : Jt(n, t);
};
function nr() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function rr() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function eo() {
  return /apple/i.test(navigator.vendor);
}
function Qt() {
  const e = /android/i;
  return e.test(nr()) || e.test(rr());
}
function to() {
  return rr().includes("jsdom/");
}
const mn = "data-floating-ui-focusable", no = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Vt = "ArrowLeft", $t = "ArrowRight", ro = "ArrowUp", oo = "ArrowDown";
function Ce(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function ue(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && vt(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Te(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function Bt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function io(e) {
  return e.matches("html,body");
}
function pe(e) {
  return e?.ownerDocument || document;
}
function or(e) {
  return te(e) && e.matches(no);
}
function en(e) {
  return e ? e.getAttribute("role") === "combobox" && or(e) : !1;
}
function Ct(e) {
  return e ? e.hasAttribute(mn) ? e : e.querySelector("[" + mn + "]") || e : null;
}
function Ne(e, t, n) {
  return n === void 0 && (n = !0), e.filter((o) => {
    var s;
    return o.parentId === t && (!n || ((s = o.context) == null ? void 0 : s.open));
  }).flatMap((o) => [o, ...Ne(e, o.id, n)]);
}
function so(e, t) {
  let n, r = -1;
  function o(s, i) {
    i > r && (n = s, r = i), Ne(e, s).forEach((a) => {
      o(a.id, i + 1);
    });
  }
  return o(t, 0), e.find((s) => s.id === n);
}
function pn(e, t) {
  var n;
  let r = [], o = (n = e.find((s) => s.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const s = e.find((i) => i.id === o);
    o = s?.parentId, s && (r = r.concat(s));
  }
  return r;
}
function ce(e) {
  e.preventDefault(), e.stopPropagation();
}
function co(e) {
  return "nativeEvent" in e;
}
function ir(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Qt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function sr(e) {
  return to() ? !1 : !Qt() && e.width === 0 && e.height === 0 || Qt() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function hn(e, t) {
  return ["mouse", "pen"].includes(e);
}
var lo = typeof document < "u", uo = function() {
}, X = lo ? Kn : uo;
const ao = {
  ...p
};
function Se(e) {
  const t = p.useRef(e);
  return X(() => {
    t.current = e;
  }), t;
}
const fo = ao.useInsertionEffect, go = fo || ((e) => e());
function fe(e) {
  const t = p.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return go(() => {
    t.current = e;
  }), p.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function at(e, t, n) {
  return Math.floor(e / t) !== n;
}
function Xe(e, t) {
  return t < 0 || t >= e.current.length;
}
function Kt(e, t) {
  return oe(e, {
    disabledIndices: t
  });
}
function vn(e, t) {
  return oe(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function oe(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: o,
    amount: s = 1
  } = t === void 0 ? {} : t, i = n;
  do
    i += r ? -s : s;
  while (i >= 0 && i <= e.current.length - 1 && pt(e, i, o));
  return i;
}
function mo(e, t) {
  let {
    event: n,
    orientation: r,
    loop: o,
    rtl: s,
    cols: i,
    disabledIndices: c,
    minIndex: a,
    maxIndex: l,
    prevIndex: u,
    stopEvent: d = !1
  } = t, f = u;
  if (n.key === ro) {
    if (d && ce(n), u === -1)
      f = l;
    else if (f = oe(e, {
      startingIndex: f,
      amount: i,
      decrement: !0,
      disabledIndices: c
    }), o && (u - i < a || f < 0)) {
      const m = u % i, h = l % i, g = l - (h - m);
      h === m ? f = l : f = h > m ? g : g - i;
    }
    Xe(e, f) && (f = u);
  }
  if (n.key === oo && (d && ce(n), u === -1 ? f = a : (f = oe(e, {
    startingIndex: u,
    amount: i,
    disabledIndices: c
  }), o && u + i > l && (f = oe(e, {
    startingIndex: u % i - i,
    amount: i,
    disabledIndices: c
  }))), Xe(e, f) && (f = u)), r === "both") {
    const m = Be(u / i);
    n.key === (s ? Vt : $t) && (d && ce(n), u % i !== i - 1 ? (f = oe(e, {
      startingIndex: u,
      disabledIndices: c
    }), o && at(f, i, m) && (f = oe(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: c
    }))) : o && (f = oe(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: c
    })), at(f, i, m) && (f = u)), n.key === (s ? $t : Vt) && (d && ce(n), u % i !== 0 ? (f = oe(e, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: c
    }), o && at(f, i, m) && (f = oe(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: c
    }))) : o && (f = oe(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: c
    })), at(f, i, m) && (f = u));
    const h = Be(l / i) === m;
    Xe(e, f) && (o && h ? f = n.key === (s ? $t : Vt) ? l : oe(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: c
    }) : f = u);
  }
  return f;
}
function po(e, t, n) {
  const r = [];
  let o = 0;
  return e.forEach((s, i) => {
    let {
      width: c,
      height: a
    } = s;
    if (c > t && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + i + " is greater than grid columns");
    let l = !1;
    for (n && (o = 0); !l; ) {
      const u = [];
      for (let d = 0; d < c; d++)
        for (let f = 0; f < a; f++)
          u.push(o + d + f * t);
      o % t + c <= t && u.every((d) => r[d] == null) ? (u.forEach((d) => {
        r[d] = i;
      }), l = !0) : o++;
    }
  }), [...r];
}
function ho(e, t, n, r, o) {
  if (e === -1) return -1;
  const s = n.indexOf(e), i = t[e];
  switch (o) {
    case "tl":
      return s;
    case "tr":
      return i ? s + i.width - 1 : s;
    case "bl":
      return i ? s + (i.height - 1) * r : s;
    case "br":
      return n.lastIndexOf(e);
  }
}
function vo(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function pt(e, t, n) {
  if (typeof n == "function")
    return n(t);
  if (n)
    return n.includes(t);
  const r = e.current[t];
  return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
const tt = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function cr(e, t) {
  const n = Dt(e, tt()), r = n.length;
  if (r === 0) return;
  const o = Ce(pe(e)), s = n.indexOf(o), i = s === -1 ? t === 1 ? 0 : r - 1 : s + t;
  return n[i];
}
function lr(e) {
  return cr(pe(e).body, 1) || e;
}
function ur(e) {
  return cr(pe(e).body, -1) || e;
}
function Ye(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !ue(n, r);
}
function bo(e) {
  Dt(e, tt()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function bn(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function wn(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = ye(t), i = Gn(t), c = jn(i), a = We(t), l = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[c] / 2 - o[c] / 2;
  let m;
  switch (a) {
    case "top":
      m = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const h = et(t);
  return h && (m[i] += f * (h === "end" ? 1 : -1) * (n && l ? -1 : 1)), m;
}
async function wo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: c,
    strategy: a
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = Qe(t, e), h = _r(m), x = c[f ? d === "floating" ? "reference" : "floating" : d], b = yt(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(x))) == null || n ? x : x.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: a
  })), w = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, E = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating)), I = await (s.isElement == null ? void 0 : s.isElement(E)) && await (s.getScale == null ? void 0 : s.getScale(E)) || {
    x: 1,
    y: 1
  }, O = yt(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: w,
    offsetParent: E,
    strategy: a
  }) : w);
  return {
    top: (b.top - O.top + h.top) / I.y,
    bottom: (O.bottom - b.bottom + h.bottom) / I.y,
    left: (b.left - O.left + h.left) / I.x,
    right: (O.right - b.right + h.right) / I.x
  };
}
const yo = 50, xo = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, c = i.detectOverflow ? i : {
    ...i,
    detectOverflow: wo
  }, a = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = wn(l, r, a), f = r, m = 0;
  const h = {};
  for (let g = 0; g < s.length; g++) {
    const x = s[g];
    if (!x)
      continue;
    const {
      name: b,
      fn: w
    } = x, {
      x: E,
      y: I,
      data: O,
      reset: S
    } = await w({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = E ?? u, d = I ?? d, h[b] = {
      ...h[b],
      ...O
    }, S && m < yo && (m++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (l = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: u,
      y: d
    } = wn(l, f, a)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
}, Ro = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: i,
        initialPlacement: c,
        platform: a,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...x
      } = Qe(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = We(o), w = ye(c), E = We(c) === c, I = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), O = f || (E || !g ? [wt(c)] : kr(c)), S = h !== "none";
      !f && S && O.push(...Nr(c, g, h, I));
      const A = [c, ...O], P = await a.detectOverflow(t, x), J = [];
      let K = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && J.push(P[b]), d) {
        const y = Pr(o, i, I);
        J.push(P[y[0]], P[y[1]]);
      }
      if (K = [...K, {
        placement: o,
        overflows: J
      }], !J.every((y) => y <= 0)) {
        var j, ie;
        const y = (((j = s.flip) == null ? void 0 : j.index) || 0) + 1, R = A[y];
        if (R && (!(d === "alignment" ? w !== ye(R) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        K.every((v) => ye(v.placement) === w ? v.overflows[0] > 0 : !0)))
          return {
            data: {
              index: y,
              overflows: K
            },
            reset: {
              placement: R
            }
          };
        let W = (ie = K.filter((L) => L.overflows[0] <= 0).sort((L, v) => L.overflows[1] - v.overflows[1])[0]) == null ? void 0 : ie.placement;
        if (!W)
          switch (m) {
            case "bestFit": {
              var z;
              const L = (z = K.filter((v) => {
                if (S) {
                  const M = ye(v.placement);
                  return M === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((v) => [v.placement, v.overflows.filter((M) => M > 0).reduce((M, $) => M + $, 0)]).sort((v, M) => v[1] - M[1])[0]) == null ? void 0 : z[0];
              L && (W = L);
              break;
            }
            case "initialPlacement":
              W = c;
              break;
          }
        if (o !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
}, Eo = /* @__PURE__ */ new Set(["left", "top"]);
async function Io(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = We(n), c = et(n), a = ye(n) === "y", l = Eo.has(i) ? -1 : 1, u = s && a ? -1 : 1, d = Qe(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof h == "number" && (m = c === "end" ? h * -1 : h), a ? {
    x: m * u,
    y: f * l
  } : {
    x: f * l,
    y: m * u
  };
}
const Co = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: i,
        middlewareData: c
      } = t, a = await Io(t, e);
      return i === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + a.x,
        y: s + a.y,
        data: {
          ...a,
          placement: i
        }
      };
    }
  };
}, To = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: c = !1,
        limiter: a = {
          fn: (w) => {
            let {
              x: E,
              y: I
            } = w;
            return {
              x: E,
              y: I
            };
          }
        },
        ...l
      } = Qe(e, t), u = {
        x: n,
        y: r
      }, d = await s.detectOverflow(t, l), f = ye(o), m = qn(f);
      let h = u[m], g = u[f];
      const x = (w, E) => Mr(E + d[w === "y" ? "top" : "left"], E, E - d[w === "y" ? "bottom" : "right"]);
      i && (h = x(m, h)), c && (g = x(f, g));
      const b = a.fn({
        ...t,
        [m]: h,
        [f]: g
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r,
          enabled: {
            [m]: i,
            [f]: c
          }
        }
      };
    }
  };
}, So = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: s
      } = t, {
        apply: i = () => {
        },
        ...c
      } = Qe(e, t), a = await o.detectOverflow(t, c), l = We(n), u = et(n), d = ye(n) === "y", {
        width: f,
        height: m
      } = r.floating;
      let h, g;
      l === "top" || l === "bottom" ? (h = l, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = l, h = u === "end" ? "top" : "bottom");
      const x = m - a.top - a.bottom, b = f - a.left - a.right, w = ze(m - a[h], x), E = ze(f - a[g], b), I = t.middlewareData.shift, O = !I;
      let S = w, A = E;
      I != null && I.enabled.x && (A = b), I != null && I.enabled.y && (S = x), O && !u && (d ? A = f - 2 * xe(a.left, a.right) : S = m - 2 * xe(a.top, a.bottom)), await i({
        ...t,
        availableWidth: A,
        availableHeight: S
      });
      const P = await o.getDimensions(s.floating);
      return f !== P.width || m !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ar(e) {
  const t = ve(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = te(e), s = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, c = bt(n) !== s || bt(r) !== i;
  return c && (n = s, r = i), {
    width: n,
    height: r,
    $: c
  };
}
function rn(e) {
  return Y(e) ? e : e.contextElement;
}
function Ke(e) {
  const t = rn(e);
  if (!te(t))
    return Re(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = ar(t);
  let i = (s ? bt(n.width) : n.width) / r, c = (s ? bt(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
const Ao = /* @__PURE__ */ Re(0);
function fr(e) {
  const t = ae(e);
  return !Pt() || !t.visualViewport ? Ao : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Oo(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === ae(e);
}
function _e(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = rn(e);
  let i = Re(1);
  t && (r ? Y(r) && (i = Ke(r)) : i = Ke(e));
  const c = Oo(s, n, r) ? fr(s) : Re(0);
  let a = (o.left + c.x) / i.x, l = (o.top + c.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s && r) {
    const f = ae(s), m = Y(r) ? ae(r) : r;
    let h = f, g = Xt(h);
    for (; g && m !== h; ) {
      const x = Ke(g), b = g.getBoundingClientRect(), w = ve(g), E = b.left + (g.clientLeft + parseFloat(w.paddingLeft)) * x.x, I = b.top + (g.clientTop + parseFloat(w.paddingTop)) * x.y;
      a *= x.x, l *= x.y, u *= x.x, d *= x.y, a += E, l += I, h = ae(g), g = Xt(h);
    }
  }
  return yt({
    width: u,
    height: d,
    x: a,
    y: l
  });
}
function Ft(e, t) {
  const n = kt(e).scrollLeft;
  return t ? t.left + n : _e(Ee(e)).left + n;
}
function dr(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Ft(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Mo(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", i = Ee(r), c = t ? Mt(t.floating) : !1;
  if (r === i || c && s)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Re(1);
  const u = Re(0), d = te(r);
  if ((d || !s) && ((ke(r) !== "body" || Ot(i)) && (a = kt(r)), d)) {
    const m = _e(r);
    l = Ke(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  const f = i && !d && !s ? dr(i, a) : Re(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - a.scrollLeft * l.x + u.x + f.x,
    y: n.y * l.y - a.scrollTop * l.y + u.y + f.y
  };
}
function Po(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function ko(e) {
  const t = kt(e), n = e.ownerDocument.body, r = xe(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = xe(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -t.scrollLeft + Ft(e);
  const i = -t.scrollTop;
  return ve(n).direction === "rtl" && (s += xe(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: s,
    y: i
  };
}
const Do = 25;
function Fo(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = ae(e), s = Ee(e), i = o.visualViewport;
  let c = s.clientWidth, a = s.clientHeight, l = 0, u = 0;
  if (i) {
    const f = !Pt() || t === "fixed";
    r ? f || (l = -i.offsetLeft, u = -i.offsetTop) : (c = i.width, a = i.height, f && (l = i.offsetLeft, u = i.offsetTop));
  }
  if (Ft(s) <= 0) {
    const f = s.ownerDocument, m = f.body, h = getComputedStyle(m), g = f.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, x = Math.abs(s.clientWidth - m.clientWidth - g), b = getComputedStyle(s).scrollbarGutter === "stable both-edges" ? x / 2 : x;
    b <= Do && (c -= b);
  }
  return {
    width: c,
    height: a,
    x: l,
    y: u
  };
}
function Lo(e, t) {
  const n = _e(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = Ke(e), i = e.clientWidth * s.x, c = e.clientHeight * s.y, a = o * s.x, l = r * s.y;
  return {
    width: i,
    height: c,
    x: a,
    y: l
  };
}
function yn(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = Fo(e, n, t);
  else if (t === "document")
    r = ko(Ee(e));
  else if (Y(t))
    r = Lo(t, n);
  else {
    const o = fr(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return yt(r);
}
function No(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Me(e, [], !1).filter((c) => Y(c) && ke(c) !== "body"), o = null;
  const s = ve(e).position === "fixed";
  let i = s ? Pe(e) : e;
  for (; Y(i) && !Oe(i); ) {
    const c = ve(i), a = nn(i), l = o ? o.position : s ? "fixed" : "";
    !a && (l === "fixed" || l === "absolute" && c.position === "static") ? r = r.filter((d) => d !== i) : o = c, i = Pe(i);
  }
  return t.set(e, r), r;
}
function Wo(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Mt(t) ? [] : No(t, this._c) : [].concat(n), r], c = yn(t, i[0], o);
  let a = c.top, l = c.right, u = c.bottom, d = c.left;
  for (let f = 1; f < i.length; f++) {
    const m = yn(t, i[f], o);
    a = xe(m.top, a), l = ze(m.right, l), u = ze(m.bottom, u), d = xe(m.left, d);
  }
  return {
    width: l - d,
    height: u - a,
    x: d,
    y: a
  };
}
function _o(e) {
  const {
    width: t,
    height: n
  } = ar(e);
  return {
    width: t,
    height: n
  };
}
function Vo(e, t, n) {
  const r = te(t), o = Ee(t), s = n === "fixed", i = _e(e, !0, s, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = Re(0);
  if ((r || !s) && ((ke(t) !== "body" || Ot(o)) && (c = kt(t)), r)) {
    const f = _e(t, !0, s, t);
    a.x = f.x + t.clientLeft, a.y = f.y + t.clientTop;
  }
  !r && o && (a.x = Ft(o));
  const l = o && !r && !s ? dr(o, c) : Re(0), u = i.left + c.scrollLeft - a.x - l.x, d = i.top + c.scrollTop - a.y - l.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function Ht(e) {
  return ve(e).position === "static";
}
function xn(e, t) {
  if (!te(e) || ve(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ee(e) === n && (n = n.ownerDocument.body), n;
}
function gr(e, t) {
  const n = ae(e);
  if (Mt(e))
    return n;
  if (!te(e)) {
    let o = Pe(e);
    for (; o && !Oe(o); ) {
      if (Y(o) && !Ht(o))
        return o;
      o = Pe(o);
    }
    return n;
  }
  let r = xn(e, t);
  for (; r && Cr(r) && Ht(r); )
    r = xn(r, t);
  return r && Oe(r) && Ht(r) && !nn(r) ? n : r || Ar(e) || n;
}
const $o = async function(e) {
  const t = this.getOffsetParent || gr, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Vo(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Bo(e) {
  return ve(e).direction === "rtl";
}
const Ko = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Mo,
  getDocumentElement: Ee,
  getClippingRect: Wo,
  getOffsetParent: gr,
  getElementRects: $o,
  getClientRects: Po,
  getDimensions: _o,
  getScale: Ke,
  isElement: Y,
  isRTL: Bo
};
function mr(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ho(e, t, n) {
  let r = null, o;
  const s = Ee(e);
  function i() {
    var u;
    clearTimeout(o), (u = r) == null || u.disconnect(), r = null;
  }
  function c(u, d) {
    u === void 0 && (u = !1), d === void 0 && (d = 1), i();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: h,
      width: g,
      height: x
    } = f;
    if (u || t(), !g || !x)
      return;
    const b = Be(h), w = Be(s.clientWidth - (m + g)), E = Be(s.clientHeight - (h + x)), I = Be(m), S = {
      rootMargin: -b + "px " + -w + "px " + -E + "px " + -I + "px",
      threshold: xe(0, ze(1, d)) || 1
    };
    let A = !0;
    function P(J) {
      const K = J[0].intersectionRatio;
      if (!mr(f, e.getBoundingClientRect()))
        return c();
      if (K !== d) {
        if (!A)
          return c();
        K ? c(!1, K) : o = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      r = new IntersectionObserver(P, {
        ...S,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(P, S);
    }
    r.observe(e);
  }
  const a = ae(e), l = () => c(n);
  return a.addEventListener("resize", l), c(!0), () => {
    a.removeEventListener("resize", l), i();
  };
}
function Ei(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = r, l = rn(e), u = o || s ? [...l ? Me(l) : [], ...t ? Me(t) : []] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n), s && b.addEventListener("resize", n);
  });
  const d = l && c ? Ho(l, n, s) : null;
  let f = -1, m = null;
  i && (m = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === l && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var E;
      (E = m) == null || E.observe(t);
    })), n();
  }), l && !a && m.observe(l), t && m.observe(t));
  let h, g = a ? _e(e) : null;
  a && x();
  function x() {
    const b = _e(e);
    g && !mr(g, b) && n(), g = b, h = requestAnimationFrame(x);
  }
  return n(), () => {
    var b;
    u.forEach((w) => {
      o && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), d?.(), (b = m) == null || b.disconnect(), m = null, a && cancelAnimationFrame(h);
  };
}
const zo = Co, Uo = To, qo = Ro, jo = So, Go = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, s = {
    ...Ko,
    ...o.platform,
    _c: r
  };
  return xo(e, t, {
    ...o,
    platform: s
  });
};
var Xo = typeof document < "u", Yo = function() {
}, ht = Xo ? Kn : Yo;
function Tt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Tt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !Tt(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function pr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rn(e, t) {
  const n = pr(e);
  return Math.round(t * n) / n;
}
function zt(e) {
  const t = p.useRef(e);
  return ht(() => {
    t.current = e;
  }), t;
}
function Zo(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: c = !0,
    whileElementsMounted: a,
    open: l
  } = e, [u, d] = p.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, m] = p.useState(r);
  Tt(f, r) || m(r);
  const [h, g] = p.useState(null), [x, b] = p.useState(null), w = p.useCallback((v) => {
    v !== S.current && (S.current = v, g(v));
  }, []), E = p.useCallback((v) => {
    v !== A.current && (A.current = v, b(v));
  }, []), I = s || h, O = i || x, S = p.useRef(null), A = p.useRef(null), P = p.useRef(u), J = a != null, K = zt(a), j = zt(o), ie = zt(l), z = p.useCallback(() => {
    if (!S.current || !A.current)
      return;
    const v = {
      placement: t,
      strategy: n,
      middleware: f
    };
    j.current && (v.platform = j.current), Go(S.current, A.current, v).then((M) => {
      const $ = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: ie.current !== !1
      };
      y.current && !Tt(P.current, $) && (P.current = $, zn.flushSync(() => {
        d($);
      }));
    });
  }, [f, t, n, j, ie]);
  ht(() => {
    l === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((v) => ({
      ...v,
      isPositioned: !1
    })));
  }, [l]);
  const y = p.useRef(!1);
  ht(() => (y.current = !0, () => {
    y.current = !1;
  }), []), ht(() => {
    if (I && (S.current = I), O && (A.current = O), I && O) {
      if (K.current)
        return K.current(I, O, z);
      z();
    }
  }, [I, O, z, K, J]);
  const R = p.useMemo(() => ({
    reference: S,
    floating: A,
    setReference: w,
    setFloating: E
  }), [w, E]), W = p.useMemo(() => ({
    reference: I,
    floating: O
  }), [I, O]), L = p.useMemo(() => {
    const v = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return v;
    const M = Rn(W.floating, u.x), $ = Rn(W.floating, u.y);
    return c ? {
      ...v,
      transform: "translate(" + M + "px, " + $ + "px)",
      ...pr(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: $
    };
  }, [n, c, W.floating, u.x, u.y]);
  return p.useMemo(() => ({
    ...u,
    update: z,
    refs: R,
    elements: W,
    floatingStyles: L
  }), [u, z, R, W, L]);
}
const Ii = (e, t) => {
  const n = zo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ci = (e, t) => {
  const n = Uo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ti = (e, t) => {
  const n = qo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Si = (e, t) => {
  const n = jo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
function Ai(e) {
  const t = p.useRef(void 0), n = p.useCallback((r) => {
    const o = e.map((s) => {
      if (s != null) {
        if (typeof s == "function") {
          const i = s, c = i(r);
          return typeof c == "function" ? c : () => {
            i(null);
          };
        }
        return s.current = r, () => {
          s.current = null;
        };
      }
    });
    return () => {
      o.forEach((s) => s?.());
    };
  }, e);
  return p.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const Jo = "data-floating-ui-focusable", En = "active", In = "selected", nt = "ArrowLeft", rt = "ArrowRight", hr = "ArrowUp", Lt = "ArrowDown", Qo = {
  ...p
};
let Cn = !1, ei = 0;
const Tn = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ei++
);
function ti() {
  const [e, t] = p.useState(() => Cn ? Tn() : void 0);
  return X(() => {
    e == null && t(Tn());
  }, []), p.useEffect(() => {
    Cn = !0;
  }, []), e;
}
const ni = Qo.useId, Nt = ni || ti;
let Ze;
process.env.NODE_ENV !== "production" && (Ze = /* @__PURE__ */ new Set());
function Ut() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Ze) != null && e.has(o))) {
    var s;
    (s = Ze) == null || s.add(o), console.warn(o);
  }
}
function ri() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Ze) != null && e.has(o))) {
    var s;
    (s = Ze) == null || s.add(o), console.error(o);
  }
}
function vr() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
const br = /* @__PURE__ */ p.createContext(null), wr = /* @__PURE__ */ p.createContext(null), ot = () => {
  var e;
  return ((e = p.useContext(br)) == null ? void 0 : e.id) || null;
}, it = () => p.useContext(wr);
function Oi(e) {
  const t = Nt(), n = it(), o = ot();
  return X(() => {
    if (!t) return;
    const s = {
      id: t,
      parentId: o
    };
    return n?.addNode(s), () => {
      n?.removeNode(s);
    };
  }, [n, t, o]), t;
}
function Mi(e) {
  const {
    children: t,
    id: n
  } = e, r = ot();
  return /* @__PURE__ */ he(br.Provider, {
    value: p.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: t
  });
}
function Pi(e) {
  const {
    children: t
  } = e, n = p.useRef([]), r = p.useCallback((i) => {
    n.current = [...n.current, i];
  }, []), o = p.useCallback((i) => {
    n.current = n.current.filter((c) => c !== i);
  }, []), [s] = p.useState(() => vr());
  return /* @__PURE__ */ he(wr.Provider, {
    value: p.useMemo(() => ({
      nodesRef: n,
      addNode: r,
      removeNode: o,
      events: s
    }), [r, o, s]),
    children: t
  });
}
function Je(e) {
  return "data-floating-ui-" + e;
}
function oi(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
let Sn = 0;
function Le(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(Sn);
  const s = () => e?.focus({
    preventScroll: n
  });
  o ? s() : Sn = requestAnimationFrame(s);
}
function ii(e) {
  return e?.ownerDocument || document;
}
const He = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function An(e) {
  return e === "inert" ? He.inert : e === "aria-hidden" ? He["aria-hidden"] : He.none;
}
let ft = /* @__PURE__ */ new WeakSet(), dt = {}, qt = 0;
const si = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function yr(e) {
  return e ? vt(e) ? e.host : yr(e.parentNode) : null;
}
const ci = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = yr(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function li(e, t, n, r) {
  const o = "data-floating-ui-inert", s = r ? "inert" : n ? "aria-hidden" : null, i = ci(t, e), c = /* @__PURE__ */ new Set(), a = new Set(i), l = [];
  dt[o] || (dt[o] = /* @__PURE__ */ new WeakMap());
  const u = dt[o];
  i.forEach(d), f(t), c.clear();
  function d(m) {
    !m || c.has(m) || (c.add(m), m.parentNode && d(m.parentNode));
  }
  function f(m) {
    !m || a.has(m) || [].forEach.call(m.children, (h) => {
      if (ke(h) !== "script")
        if (c.has(h))
          f(h);
        else {
          const g = s ? h.getAttribute(s) : null, x = g !== null && g !== "false", b = An(s), w = (b.get(h) || 0) + 1, E = (u.get(h) || 0) + 1;
          b.set(h, w), u.set(h, E), l.push(h), w === 1 && x && ft.add(h), E === 1 && h.setAttribute(o, ""), !x && s && h.setAttribute(s, s === "inert" ? "" : "true");
        }
    });
  }
  return qt++, () => {
    l.forEach((m) => {
      const h = An(s), x = (h.get(m) || 0) - 1, b = (u.get(m) || 0) - 1;
      h.set(m, x), u.set(m, b), x || (!ft.has(m) && s && m.removeAttribute(s), ft.delete(m)), b || m.removeAttribute(o);
    }), qt--, qt || (He.inert = /* @__PURE__ */ new WeakMap(), He["aria-hidden"] = /* @__PURE__ */ new WeakMap(), He.none = /* @__PURE__ */ new WeakMap(), ft = /* @__PURE__ */ new WeakSet(), dt = {});
  };
}
function On(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = ii(e[0]).body;
  return li(e.concat(Array.from(r.querySelectorAll('[aria-live],[role="status"],output'))), r, t, n);
}
const on = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, St = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const [r, o] = p.useState();
  X(() => {
    eo() && o("button");
  }, []);
  const s = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Je("focus-guard")]: "",
    style: on
  };
  return /* @__PURE__ */ he("span", {
    ...t,
    ...s
  });
}), ui = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, xr = /* @__PURE__ */ p.createContext(null), Mn = /* @__PURE__ */ Je("portal");
function ai(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = Nt(), o = Rr(), [s, i] = p.useState(null), c = p.useRef(null);
  return X(() => () => {
    s?.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [s]), X(() => {
    if (!r || c.current) return;
    const a = t ? document.getElementById(t) : null;
    if (!a) return;
    const l = document.createElement("div");
    l.id = r, l.setAttribute(Mn, ""), a.appendChild(l), c.current = l, i(l);
  }, [t, r]), X(() => {
    if (n === null || !r || c.current) return;
    let a = n || o?.portalNode;
    a && !tn(a) && (a = a.current), a = a || document.body;
    let l = null;
    t && (l = document.createElement("div"), l.id = t, a.appendChild(l));
    const u = document.createElement("div");
    u.id = r, u.setAttribute(Mn, ""), a = l || a, a.appendChild(u), c.current = u, i(u);
  }, [t, n, r, o]), s;
}
function ki(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, s = ai({
    id: n,
    root: r
  }), [i, c] = p.useState(null), a = p.useRef(null), l = p.useRef(null), u = p.useRef(null), d = p.useRef(null), f = i?.modal, m = i?.open, h = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!i && // Guards are only for non-modal focus management.
    !i.modal && // Don't render if unmount is transitioning.
    i.open && o && !!(r || s)
  );
  return p.useEffect(() => {
    if (!s || !o || f)
      return;
    function g(x) {
      s && Ye(x) && (x.type === "focusin" ? bn : bo)(s);
    }
    return s.addEventListener("focusin", g, !0), s.addEventListener("focusout", g, !0), () => {
      s.removeEventListener("focusin", g, !0), s.removeEventListener("focusout", g, !0);
    };
  }, [s, o, f]), p.useEffect(() => {
    s && (m || bn(s));
  }, [m, s]), /* @__PURE__ */ Hn(xr.Provider, {
    value: p.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: a,
      afterOutsideRef: l,
      beforeInsideRef: u,
      afterInsideRef: d,
      portalNode: s,
      setFocusManagerState: c
    }), [o, s]),
    children: [h && s && /* @__PURE__ */ he(St, {
      "data-type": "outside",
      ref: a,
      onFocus: (g) => {
        if (Ye(g, s)) {
          var x;
          (x = u.current) == null || x.focus();
        } else {
          const b = i ? i.domReference : null, w = ur(b);
          w?.focus();
        }
      }
    }), h && s && /* @__PURE__ */ he("span", {
      "aria-owns": s.id,
      style: ui
    }), s && /* @__PURE__ */ zn.createPortal(t, s), h && s && /* @__PURE__ */ he(St, {
      "data-type": "outside",
      ref: l,
      onFocus: (g) => {
        if (Ye(g, s)) {
          var x;
          (x = d.current) == null || x.focus();
        } else {
          const b = i ? i.domReference : null, w = lr(b);
          w?.focus(), i?.closeOnFocusOut && i?.onOpenChange(!1, g.nativeEvent, "focus-out");
        }
      }
    })]
  });
}
const Rr = () => p.useContext(xr);
function Pn(e) {
  return p.useMemo(() => (t) => {
    e.forEach((n) => {
      n && (n.current = t);
    });
  }, e);
}
const kn = 20;
let Ae = [];
function sn() {
  Ae = Ae.filter((e) => {
    var t;
    return (t = e.deref()) == null ? void 0 : t.isConnected;
  });
}
function fi(e) {
  sn(), e && ke(e) !== "body" && (Ae.push(new WeakRef(e)), Ae.length > kn && (Ae = Ae.slice(-kn)));
}
function Dn() {
  sn();
  const e = Ae[Ae.length - 1];
  return e?.deref();
}
function di(e) {
  const t = tt();
  return tr(e, t) ? e : Dt(e, t)[0] || e;
}
function Fn(e, t) {
  var n;
  if (!t.current.includes("floating") && !((n = e.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const r = tt(), s = Qr(e, r).filter((c) => {
    const a = c.getAttribute("data-tabindex") || "";
    return tr(c, r) || c.hasAttribute("data-tabindex") && !a.startsWith("-");
  }), i = e.getAttribute("tabindex");
  t.current.includes("floating") || s.length === 0 ? i !== "0" && e.setAttribute("tabindex", "0") : (i !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
const gi = /* @__PURE__ */ p.forwardRef(function(t, n) {
  return /* @__PURE__ */ he("button", {
    ...t,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: on
  });
});
function Di(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: s = !0,
    initialFocus: i = 0,
    returnFocus: c = !0,
    restoreFocus: a = !1,
    modal: l = !0,
    visuallyHiddenDismiss: u = !1,
    closeOnFocusOut: d = !0,
    outsideElementsInert: f = !1,
    getInsideElements: m = () => []
  } = e, {
    open: h,
    onOpenChange: g,
    events: x,
    dataRef: b,
    elements: {
      domReference: w,
      floating: E
    }
  } = t, I = fe(() => {
    var k;
    return (k = b.current.floatingContext) == null ? void 0 : k.nodeId;
  }), O = fe(m), S = typeof i == "number" && i < 0, A = en(w) && S, P = si(), J = P ? s : !0, K = !J || P && f, j = Se(o), ie = Se(i), z = Se(c), y = it(), R = Rr(), W = p.useRef(null), L = p.useRef(null), v = p.useRef(!1), M = p.useRef(!1), $ = p.useRef(-1), le = p.useRef(-1), de = R != null, N = Ct(E), Q = fe(function(k) {
    return k === void 0 && (k = N), k ? Dt(k, tt()) : [];
  }), H = fe((k) => {
    const _ = Q(k);
    return j.current.map((D) => w && D === "reference" ? w : N && D === "floating" ? N : _).filter(Boolean).flat();
  });
  p.useEffect(() => {
    if (r || !l) return;
    function k(D) {
      if (D.key === "Tab") {
        ue(N, Ce(pe(N))) && Q().length === 0 && !A && ce(D);
        const U = H(), G = Te(D);
        j.current[0] === "reference" && G === w && (ce(D), D.shiftKey ? Le(U[U.length - 1]) : Le(U[1])), j.current[1] === "floating" && G === N && D.shiftKey && (ce(D), Le(U[0]));
      }
    }
    const _ = pe(N);
    return _.addEventListener("keydown", k), () => {
      _.removeEventListener("keydown", k);
    };
  }, [r, w, N, l, j, A, Q, H]), p.useEffect(() => {
    if (r || !E) return;
    function k(_) {
      const D = Te(_), G = Q().indexOf(D);
      G !== -1 && ($.current = G);
    }
    return E.addEventListener("focusin", k), () => {
      E.removeEventListener("focusin", k);
    };
  }, [r, E, Q]), p.useEffect(() => {
    if (r || !d) return;
    function k() {
      M.current = !0, setTimeout(() => {
        M.current = !1;
      });
    }
    function _(G) {
      const V = G.relatedTarget, se = G.currentTarget, ne = Te(G);
      queueMicrotask(() => {
        const re = I(), be = !(ue(w, V) || ue(E, V) || ue(V, E) || ue(R?.portalNode, V) || V != null && V.hasAttribute(Je("focus-guard")) || y && (Ne(y.nodesRef.current, re).find((T) => {
          var F, C;
          return ue((F = T.context) == null ? void 0 : F.elements.floating, V) || ue((C = T.context) == null ? void 0 : C.elements.domReference, V);
        }) || pn(y.nodesRef.current, re).find((T) => {
          var F, C, B;
          return [(F = T.context) == null ? void 0 : F.elements.floating, Ct((C = T.context) == null ? void 0 : C.elements.floating)].includes(V) || ((B = T.context) == null ? void 0 : B.elements.domReference) === V;
        })));
        if (se === w && N && Fn(N, j), a && se !== w && !(ne != null && ne.isConnected) && Ce(pe(N)) === pe(N).body) {
          te(N) && N.focus();
          const T = $.current, F = Q(), C = F[T] || F[F.length - 1] || N;
          te(C) && C.focus();
        }
        if (b.current.insideReactTree) {
          b.current.insideReactTree = !1;
          return;
        }
        (A || !l) && V && be && !M.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        V !== Dn() && (v.current = !0, g(!1, G, "focus-out"));
      });
    }
    const D = !!(!y && R);
    function U() {
      oi(le), b.current.insideReactTree = !0, le.current = window.setTimeout(() => {
        b.current.insideReactTree = !1;
      });
    }
    if (E && te(w))
      return w.addEventListener("focusout", _), w.addEventListener("pointerdown", k), E.addEventListener("focusout", _), D && E.addEventListener("focusout", U, !0), () => {
        w.removeEventListener("focusout", _), w.removeEventListener("pointerdown", k), E.removeEventListener("focusout", _), D && E.removeEventListener("focusout", U, !0);
      };
  }, [r, w, E, N, l, y, R, g, d, a, Q, A, I, j, b]);
  const ee = p.useRef(null), ge = p.useRef(null), qe = Pn([ee, R?.beforeInsideRef]), Ve = Pn([ge, R?.afterInsideRef]);
  p.useEffect(() => {
    var k, _;
    if (r || !E) return;
    const D = Array.from((R == null || (k = R.portalNode) == null ? void 0 : k.querySelectorAll("[" + Je("portal") + "]")) || []), G = (_ = (y ? pn(y.nodesRef.current, I()) : []).find((ne) => {
      var re;
      return en(((re = ne.context) == null ? void 0 : re.elements.domReference) || null);
    })) == null || (_ = _.context) == null ? void 0 : _.elements.domReference, V = [E, G, ...D, ...O(), W.current, L.current, ee.current, ge.current, R?.beforeOutsideRef.current, R?.afterOutsideRef.current, j.current.includes("reference") || A ? w : null].filter((ne) => ne != null), se = l || A ? On(V, !K, K) : On(V);
    return () => {
      se();
    };
  }, [r, w, E, l, j, R, A, J, K, y, I, O]), X(() => {
    if (r || !te(N)) return;
    const k = pe(N), _ = Ce(k);
    queueMicrotask(() => {
      const D = H(N), U = ie.current, G = (typeof U == "number" ? D[U] : U.current) || N, V = ue(N, _);
      !S && !V && h && Le(G, {
        preventScroll: G === N
      });
    });
  }, [r, h, N, S, H, ie]), X(() => {
    if (r || !N) return;
    const k = pe(N), _ = Ce(k);
    fi(_);
    function D(V) {
      let {
        reason: se,
        event: ne,
        nested: re
      } = V;
      if (["hover", "safe-polygon"].includes(se) && ne.type === "mouseleave" && (v.current = !0), se === "outside-press")
        if (re)
          v.current = !1;
        else if (ir(ne) || sr(ne))
          v.current = !1;
        else {
          let be = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return be = !0, !1;
            }
          }), be ? v.current = !1 : v.current = !0;
        }
    }
    x.on("openchange", D);
    const U = k.createElement("span");
    U.setAttribute("tabindex", "-1"), U.setAttribute("aria-hidden", "true"), Object.assign(U.style, on), de && w && w.insertAdjacentElement("afterend", U);
    function G() {
      if (typeof z.current == "boolean") {
        const V = w || Dn();
        return V && V.isConnected ? V : U;
      }
      return z.current.current || U;
    }
    return () => {
      x.off("openchange", D);
      const V = Ce(k), se = ue(E, V) || y && Ne(y.nodesRef.current, I(), !1).some((re) => {
        var be;
        return ue((be = re.context) == null ? void 0 : be.elements.floating, V);
      }), ne = G();
      queueMicrotask(() => {
        const re = di(ne);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        z.current && !v.current && te(re) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(re !== V && V !== k.body) || se) && re.focus({
          preventScroll: !0
        }), U.remove();
      });
    };
  }, [r, E, N, z, b, x, y, de, w, I]), p.useEffect(() => (queueMicrotask(() => {
    v.current = !1;
  }), () => {
    queueMicrotask(sn);
  }), [r]), X(() => {
    if (!r && R)
      return R.setFocusManagerState({
        modal: l,
        closeOnFocusOut: d,
        open: h,
        onOpenChange: g,
        domReference: w
      }), () => {
        R.setFocusManagerState(null);
      };
  }, [r, R, l, h, g, d, w]), X(() => {
    r || N && Fn(N, j);
  }, [r, N, j]);
  function we(k) {
    return r || !u || !l ? null : /* @__PURE__ */ he(gi, {
      ref: k === "start" ? W : L,
      onClick: (_) => g(!1, _.nativeEvent),
      children: typeof u == "string" ? u : "Dismiss"
    });
  }
  const $e = !r && J && (l ? !A : !0) && (de || l);
  return /* @__PURE__ */ Hn(Ir, {
    children: [$e && /* @__PURE__ */ he(St, {
      "data-type": "inside",
      ref: qe,
      onFocus: (k) => {
        if (l) {
          const D = H();
          Le(o[0] === "reference" ? D[0] : D[D.length - 1]);
        } else if (R != null && R.preserveTabOrder && R.portalNode)
          if (v.current = !1, Ye(k, R.portalNode)) {
            const D = lr(w);
            D?.focus();
          } else {
            var _;
            (_ = R.beforeOutsideRef.current) == null || _.focus();
          }
      }
    }), !A && we("start"), n, we("end"), $e && /* @__PURE__ */ he(St, {
      "data-type": "inside",
      ref: Ve,
      onFocus: (k) => {
        if (l)
          Le(H()[0]);
        else if (R != null && R.preserveTabOrder && R.portalNode)
          if (d && (v.current = !0), Ye(k, R.portalNode)) {
            const D = ur(w);
            D?.focus();
          } else {
            var _;
            (_ = R.afterOutsideRef.current) == null || _.focus();
          }
      }
    })]
  });
}
let gt = 0;
const Ln = "--floating-ui-scrollbar-width";
function mi() {
  const e = nr(), t = /iP(hone|ad|od)|iOS/.test(e) || // iPads can claim to be MacIntel
  e === "MacIntel" && navigator.maxTouchPoints > 1, n = document.body.style, o = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", s = window.innerWidth - document.documentElement.clientWidth, i = n.left ? parseFloat(n.left) : window.scrollX, c = n.top ? parseFloat(n.top) : window.scrollY;
  if (n.overflow = "hidden", n.setProperty(Ln, s + "px"), s && (n[o] = s + "px"), t) {
    var a, l;
    const u = ((a = window.visualViewport) == null ? void 0 : a.offsetLeft) || 0, d = ((l = window.visualViewport) == null ? void 0 : l.offsetTop) || 0;
    Object.assign(n, {
      position: "fixed",
      top: -(c - Math.floor(d)) + "px",
      left: -(i - Math.floor(u)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(n, {
      overflow: "",
      [o]: ""
    }), n.removeProperty(Ln), t && (Object.assign(n, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(i, c));
  };
}
let Nn = () => {
};
const Fi = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const {
    lockScroll: r = !1,
    ...o
  } = t;
  return X(() => {
    if (r)
      return gt++, gt === 1 && (Nn = mi()), () => {
        gt--, gt === 0 && Nn();
      };
  }, [r]), /* @__PURE__ */ he("div", {
    ref: n,
    ...o,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...o.style
    }
  });
});
function Wn(e) {
  return te(e.target) && e.target.tagName === "BUTTON";
}
function pi(e) {
  return te(e.target) && e.target.tagName === "A";
}
function _n(e) {
  return or(e);
}
function Li(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: s
    }
  } = e, {
    enabled: i = !0,
    event: c = "click",
    toggle: a = !0,
    ignoreMouse: l = !1,
    keyboardHandlers: u = !0,
    stickIfOpen: d = !0
  } = t, f = p.useRef(), m = p.useRef(!1), h = p.useMemo(() => ({
    onPointerDown(g) {
      f.current = g.pointerType;
    },
    onMouseDown(g) {
      const x = f.current;
      g.button === 0 && c !== "click" && (hn(x) && l || (n && a && (!(o.current.openEvent && d) || o.current.openEvent.type === "mousedown") ? r(!1, g.nativeEvent, "click") : (g.preventDefault(), r(!0, g.nativeEvent, "click"))));
    },
    onClick(g) {
      const x = f.current;
      if (c === "mousedown" && f.current) {
        f.current = void 0;
        return;
      }
      hn(x) && l || (n && a && (!(o.current.openEvent && d) || o.current.openEvent.type === "click") ? r(!1, g.nativeEvent, "click") : r(!0, g.nativeEvent, "click"));
    },
    onKeyDown(g) {
      f.current = void 0, !(g.defaultPrevented || !u || Wn(g)) && (g.key === " " && !_n(s) && (g.preventDefault(), m.current = !0), !pi(g) && g.key === "Enter" && r(!(n && a), g.nativeEvent, "click"));
    },
    onKeyUp(g) {
      g.defaultPrevented || !u || Wn(g) || _n(s) || g.key === " " && m.current && (m.current = !1, r(!(n && a), g.nativeEvent, "click"));
    }
  }), [o, s, c, l, u, r, n, d, a]);
  return p.useMemo(() => i ? {
    reference: h
  } : {}, [i, h]);
}
const hi = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, vi = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Vn = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function Ni(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: s
  } = e, {
    enabled: i = !0,
    escapeKey: c = !0,
    outsidePress: a = !0,
    outsidePressEvent: l = "pointerdown",
    referencePress: u = !1,
    referencePressEvent: d = "pointerdown",
    ancestorScroll: f = !1,
    bubbles: m,
    capture: h
  } = t, g = it(), x = fe(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? x : a, w = p.useRef(!1), {
    escapeKey: E,
    outsidePress: I
  } = Vn(m), {
    escapeKey: O,
    outsidePress: S
  } = Vn(h), A = p.useRef(!1), P = fe((y) => {
    var R;
    if (!n || !i || !c || y.key !== "Escape" || A.current)
      return;
    const W = (R = s.current.floatingContext) == null ? void 0 : R.nodeId, L = g ? Ne(g.nodesRef.current, W) : [];
    if (!E && (y.stopPropagation(), L.length > 0)) {
      let v = !0;
      if (L.forEach((M) => {
        var $;
        if (($ = M.context) != null && $.open && !M.context.dataRef.current.__escapeKeyBubbles) {
          v = !1;
          return;
        }
      }), !v)
        return;
    }
    r(!1, co(y) ? y.nativeEvent : y, "escape-key");
  }), J = fe((y) => {
    var R;
    const W = () => {
      var L;
      P(y), (L = Te(y)) == null || L.removeEventListener("keydown", W);
    };
    (R = Te(y)) == null || R.addEventListener("keydown", W);
  }), K = fe((y) => {
    var R;
    const W = s.current.insideReactTree;
    s.current.insideReactTree = !1;
    const L = w.current;
    if (w.current = !1, l === "click" && L || W || typeof b == "function" && !b(y))
      return;
    const v = Te(y), M = "[" + Je("inert") + "]", $ = pe(o.floating).querySelectorAll(M);
    let le = Y(v) ? v : null;
    for (; le && !Oe(le); ) {
      const H = Pe(le);
      if (Oe(H) || !Y(H))
        break;
      le = H;
    }
    if ($.length && Y(v) && !io(v) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !ue(v, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from($).every((H) => !ue(le, H)))
      return;
    if (te(v) && z) {
      const H = Oe(v), ee = ve(v), ge = /auto|scroll/, qe = H || ge.test(ee.overflowX), Ve = H || ge.test(ee.overflowY), we = qe && v.clientWidth > 0 && v.scrollWidth > v.clientWidth, $e = Ve && v.clientHeight > 0 && v.scrollHeight > v.clientHeight, k = ee.direction === "rtl", _ = $e && (k ? y.offsetX <= v.offsetWidth - v.clientWidth : y.offsetX > v.clientWidth), D = we && y.offsetY > v.clientHeight;
      if (_ || D)
        return;
    }
    const de = (R = s.current.floatingContext) == null ? void 0 : R.nodeId, N = g && Ne(g.nodesRef.current, de).some((H) => {
      var ee;
      return Bt(y, (ee = H.context) == null ? void 0 : ee.elements.floating);
    });
    if (Bt(y, o.floating) || Bt(y, o.domReference) || N)
      return;
    const Q = g ? Ne(g.nodesRef.current, de) : [];
    if (Q.length > 0) {
      let H = !0;
      if (Q.forEach((ee) => {
        var ge;
        if ((ge = ee.context) != null && ge.open && !ee.context.dataRef.current.__outsidePressBubbles) {
          H = !1;
          return;
        }
      }), !H)
        return;
    }
    r(!1, y, "outside-press");
  }), j = fe((y) => {
    var R;
    const W = () => {
      var L;
      K(y), (L = Te(y)) == null || L.removeEventListener(l, W);
    };
    (R = Te(y)) == null || R.addEventListener(l, W);
  });
  p.useEffect(() => {
    if (!n || !i)
      return;
    s.current.__escapeKeyBubbles = E, s.current.__outsidePressBubbles = I;
    let y = -1;
    function R($) {
      r(!1, $, "ancestor-scroll");
    }
    function W() {
      window.clearTimeout(y), A.current = !0;
    }
    function L() {
      y = window.setTimeout(
        () => {
          A.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Pt() ? 5 : 0
      );
    }
    const v = pe(o.floating);
    c && (v.addEventListener("keydown", O ? J : P, O), v.addEventListener("compositionstart", W), v.addEventListener("compositionend", L)), b && v.addEventListener(l, S ? j : K, S);
    let M = [];
    return f && (Y(o.domReference) && (M = Me(o.domReference)), Y(o.floating) && (M = M.concat(Me(o.floating))), !Y(o.reference) && o.reference && o.reference.contextElement && (M = M.concat(Me(o.reference.contextElement)))), M = M.filter(($) => {
      var le;
      return $ !== ((le = v.defaultView) == null ? void 0 : le.visualViewport);
    }), M.forEach(($) => {
      $.addEventListener("scroll", R);
    }), () => {
      c && (v.removeEventListener("keydown", O ? J : P, O), v.removeEventListener("compositionstart", W), v.removeEventListener("compositionend", L)), b && v.removeEventListener(l, S ? j : K, S), M.forEach(($) => {
        $.removeEventListener("scroll", R);
      }), window.clearTimeout(y);
    };
  }, [s, o, c, b, l, n, r, f, i, E, I, P, O, J, K, S, j]), p.useEffect(() => {
    s.current.insideReactTree = !1;
  }, [s, b, l]);
  const ie = p.useMemo(() => ({
    onKeyDown: P,
    ...u && {
      [hi[d]]: (y) => {
        r(!1, y.nativeEvent, "reference-press");
      },
      ...d !== "click" && {
        onClick(y) {
          r(!1, y.nativeEvent, "reference-press");
        }
      }
    }
  }), [P, r, u, d]), z = p.useMemo(() => {
    function y(R) {
      R.button === 0 && (w.current = !0);
    }
    return {
      onKeyDown: P,
      onMouseDown: y,
      onMouseUp: y,
      [vi[l]]: () => {
        s.current.insideReactTree = !0;
      }
    };
  }, [P, l, s]);
  return p.useMemo(() => i ? {
    reference: ie,
    floating: z
  } : {}, [i, ie, z]);
}
function bi(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = Nt(), s = p.useRef({}), [i] = p.useState(() => vr()), c = ot() != null;
  if (process.env.NODE_ENV !== "production") {
    const m = r.reference;
    m && !Y(m) && ri("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [a, l] = p.useState(r.reference), u = fe((m, h, g) => {
    s.current.openEvent = m ? h : void 0, i.emit("openchange", {
      open: m,
      event: h,
      reason: g,
      nested: c
    }), n?.(m, h, g);
  }), d = p.useMemo(() => ({
    setPositionReference: l
  }), []), f = p.useMemo(() => ({
    reference: a || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [a, r.reference, r.floating]);
  return p.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: u,
    elements: f,
    events: i,
    floatingId: o,
    refs: d
  }), [t, u, f, i, o, d]);
}
function Wi(e) {
  var t, n;
  let {
    elements: r,
    ...o
  } = e === void 0 ? {} : e;
  const {
    nodeId: s
  } = o, i = bi({
    ...o,
    elements: {
      reference: (t = r?.reference) != null ? t : null,
      floating: (n = r?.floating) != null ? n : null
    }
  }), c = o.rootContext || i, a = c.elements, [l, u] = p.useState(null), [d, f] = p.useState(null), h = a?.domReference || l, g = p.useRef(null), x = it();
  X(() => {
    h && (g.current = h);
  }, [h]);
  const b = Zo({
    ...o,
    elements: {
      ...a,
      ...d && {
        reference: d
      }
    }
  }), w = p.useCallback((A) => {
    const P = Y(A) ? {
      getBoundingClientRect: () => A.getBoundingClientRect(),
      getClientRects: () => A.getClientRects(),
      contextElement: A
    } : A;
    f(P), b.refs.setReference(P);
  }, [b.refs]), E = p.useCallback((A) => {
    (Y(A) || A === null) && (g.current = A, u(A)), (Y(b.refs.reference.current) || b.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    A !== null && !Y(A)) && b.refs.setReference(A);
  }, [b.refs]), I = p.useMemo(() => ({
    ...b.refs,
    setReference: E,
    setPositionReference: w,
    domReference: g
  }), [b.refs, E, w]), O = p.useMemo(() => ({
    ...b.elements,
    domReference: h
  }), [b.elements, h]), S = p.useMemo(() => ({
    ...b,
    ...c,
    refs: I,
    elements: O,
    nodeId: s
  }), [b, I, O, s, c]);
  return X(() => {
    c.dataRef.current.floatingContext = S;
    const A = x?.nodesRef.current.find((P) => P.id === s);
    A && (A.context = S);
  }), p.useMemo(() => ({
    ...b,
    context: S,
    refs: I,
    elements: O
  }), [b, I, O, S]);
}
function jt(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let s = e;
  if (o && e) {
    const {
      [En]: i,
      [In]: c,
      ...a
    } = e;
    s = a;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Jo]: ""
    },
    ...s,
    ...t.map((i) => {
      const c = i ? i[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((i, c) => (c && Object.entries(c).forEach((a) => {
      let [l, u] = a;
      if (!(o && [En, In].includes(l)))
        if (l.indexOf("on") === 0) {
          if (r.has(l) || r.set(l, []), typeof u == "function") {
            var d;
            (d = r.get(l)) == null || d.push(u), i[l] = function() {
              for (var f, m = arguments.length, h = new Array(m), g = 0; g < m; g++)
                h[g] = arguments[g];
              return (f = r.get(l)) == null ? void 0 : f.map((x) => x(...h)).find((x) => x !== void 0);
            };
          }
        } else
          i[l] = u;
    }), i), {})
  };
}
function _i(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c?.reference), n = e.map((c) => c?.floating), r = e.map((c) => c?.item), o = p.useCallback(
    (c) => jt(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = p.useCallback(
    (c) => jt(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = p.useCallback(
    (c) => jt(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return p.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: s,
    getItemProps: i
  }), [o, s, i]);
}
const wi = "Escape";
function Wt(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function mt(e, t) {
  return Wt(t, e === hr || e === Lt, e === nt || e === rt);
}
function Gt(e, t, n) {
  return Wt(t, e === Lt, n ? e === nt : e === rt) || e === "Enter" || e === " " || e === "";
}
function $n(e, t, n) {
  return Wt(t, n ? e === nt : e === rt, e === Lt);
}
function Bn(e, t, n, r) {
  const o = n ? e === rt : e === nt, s = e === hr;
  return t === "both" || t === "horizontal" && r && r > 1 ? e === wi : Wt(t, o, s);
}
function Vi(e, t) {
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    floatingId: s
  } = e, {
    listRef: i,
    activeIndex: c,
    onNavigate: a = () => {
    },
    enabled: l = !0,
    selectedIndex: u = null,
    allowEscape: d = !1,
    loop: f = !1,
    nested: m = !1,
    rtl: h = !1,
    virtual: g = !1,
    focusItemOnOpen: x = "auto",
    focusItemOnHover: b = !0,
    openOnArrowKeyDown: w = !0,
    disabledIndices: E = void 0,
    orientation: I = "vertical",
    parentOrientation: O,
    cols: S = 1,
    scrollItemIntoView: A = !0,
    virtualItemRef: P,
    itemSizes: J,
    dense: K = !1
  } = t;
  process.env.NODE_ENV !== "production" && (d && (f || Ut("`useListNavigation` looping must be enabled to allow escaping."), g || Ut("`useListNavigation` must be virtual to allow escaping.")), I === "vertical" && S > 1 && Ut("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const j = Ct(o.floating), ie = Se(j), z = ot(), y = it();
  X(() => {
    e.dataRef.current.orientation = I;
  }, [e, I]);
  const R = fe(() => {
    a(v.current === -1 ? null : v.current);
  }), W = en(o.domReference), L = p.useRef(x), v = p.useRef(u ?? -1), M = p.useRef(null), $ = p.useRef(!0), le = p.useRef(R), de = p.useRef(!!o.floating), N = p.useRef(n), Q = p.useRef(!1), H = p.useRef(!1), ee = Se(E), ge = Se(n), qe = Se(A), Ve = Se(u), [we, $e] = p.useState(), [k, _] = p.useState(), D = fe(() => {
    function T(q) {
      if (g) {
        var Z;
        (Z = q.id) != null && Z.endsWith("-fui-option") && (q.id = s + "-" + Math.random().toString(16).slice(2, 10)), $e(q.id), y?.events.emit("virtualfocus", q), P && (P.current = q);
      } else
        Le(q, {
          sync: Q.current,
          preventScroll: !0
        });
    }
    const F = i.current[v.current], C = H.current;
    F && T(F), (Q.current ? (q) => q() : requestAnimationFrame)(() => {
      const q = i.current[v.current] || F;
      if (!q) return;
      F || T(q);
      const Z = qe.current;
      Z && G && (C || !$.current) && (q.scrollIntoView == null || q.scrollIntoView(typeof Z == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : Z));
    });
  });
  X(() => {
    l && (n && o.floating ? L.current && u != null && (H.current = !0, v.current = u, R()) : de.current && (v.current = -1, le.current()));
  }, [l, n, o.floating, u, R]), X(() => {
    if (l && n && o.floating)
      if (c == null) {
        if (Q.current = !1, Ve.current != null)
          return;
        if (de.current && (v.current = -1, D()), (!N.current || !de.current) && L.current && (M.current != null || L.current === !0 && M.current == null)) {
          let T = 0;
          const F = () => {
            i.current[0] == null ? (T < 2 && (T ? requestAnimationFrame : queueMicrotask)(F), T++) : (v.current = M.current == null || Gt(M.current, I, h) || m ? Kt(i, ee.current) : vn(i, ee.current), M.current = null, R());
          };
          F();
        }
      } else Xe(i, c) || (v.current = c, D(), H.current = !1);
  }, [l, n, o.floating, c, Ve, m, i, I, h, R, D, ee]), X(() => {
    var T;
    if (!l || o.floating || !y || g || !de.current)
      return;
    const F = y.nodesRef.current, C = (T = F.find((Z) => Z.id === z)) == null || (T = T.context) == null ? void 0 : T.elements.floating, B = Ce(pe(o.floating)), q = F.some((Z) => Z.context && ue(Z.context.elements.floating, B));
    C && !q && $.current && C.focus({
      preventScroll: !0
    });
  }, [l, o.floating, y, z, g]), X(() => {
    if (!l || !y || !g || z) return;
    function T(F) {
      _(F.id), P && (P.current = F);
    }
    return y.events.on("virtualfocus", T), () => {
      y.events.off("virtualfocus", T);
    };
  }, [l, y, g, z, P]), X(() => {
    le.current = R, N.current = n, de.current = !!o.floating;
  }), X(() => {
    n || (M.current = null, L.current = x);
  }, [n, x]);
  const U = c != null, G = p.useMemo(() => {
    function T(C) {
      if (!ge.current) return;
      const B = i.current.indexOf(C);
      B !== -1 && v.current !== B && (v.current = B, R());
    }
    return {
      onFocus(C) {
        let {
          currentTarget: B
        } = C;
        Q.current = !0, T(B);
      },
      onClick: (C) => {
        let {
          currentTarget: B
        } = C;
        return B.focus({
          preventScroll: !0
        });
      },
      // Safari
      onMouseMove(C) {
        let {
          currentTarget: B
        } = C;
        Q.current = !0, H.current = !1, b && T(B);
      },
      onPointerLeave(C) {
        let {
          pointerType: B
        } = C;
        if (!(!$.current || B === "touch") && (Q.current = !0, !!b && (v.current = -1, R(), !g))) {
          var q;
          (q = ie.current) == null || q.focus({
            preventScroll: !0
          });
        }
      }
    };
  }, [ge, ie, b, i, R, g]), V = p.useCallback(() => {
    var T;
    return O ?? (y == null || (T = y.nodesRef.current.find((F) => F.id === z)) == null || (T = T.context) == null || (T = T.dataRef) == null ? void 0 : T.current.orientation);
  }, [z, y, O]), se = fe((T) => {
    if ($.current = !1, Q.current = !0, T.which === 229 || !ge.current && T.currentTarget === ie.current)
      return;
    if (m && Bn(T.key, I, h, S)) {
      mt(T.key, V()) || ce(T), r(!1, T.nativeEvent, "list-navigation"), te(o.domReference) && (g ? y?.events.emit("virtualfocus", o.domReference) : o.domReference.focus());
      return;
    }
    const F = v.current, C = Kt(i, E), B = vn(i, E);
    if (W || (T.key === "Home" && (ce(T), v.current = C, R()), T.key === "End" && (ce(T), v.current = B, R())), S > 1) {
      const q = J || Array.from({
        length: i.current.length
      }, () => ({
        width: 1,
        height: 1
      })), Z = po(q, S, K), je = Z.findIndex((me) => me != null && !pt(i, me, E)), st = Z.reduce((me, De, ct) => De != null && !pt(i, De, E) ? ct : me, -1), Ge = Z[mo({
        current: Z.map((me) => me != null ? i.current[me] : null)
      }, {
        event: T,
        orientation: I,
        loop: f,
        rtl: h,
        cols: S,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: vo([...(typeof E != "function" ? E : null) || i.current.map((me, De) => pt(i, De, E) ? De : void 0), void 0], Z),
        minIndex: je,
        maxIndex: st,
        prevIndex: ho(
          v.current > B ? C : v.current,
          q,
          Z,
          S,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          T.key === Lt ? "bl" : T.key === (h ? nt : rt) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Ge != null && (v.current = Ge, R()), I === "both")
        return;
    }
    if (mt(T.key, I)) {
      if (ce(T), n && !g && Ce(T.currentTarget.ownerDocument) === T.currentTarget) {
        v.current = Gt(T.key, I, h) ? C : B, R();
        return;
      }
      Gt(T.key, I, h) ? f ? v.current = F >= B ? d && F !== i.current.length ? -1 : C : oe(i, {
        startingIndex: F,
        disabledIndices: E
      }) : v.current = Math.min(B, oe(i, {
        startingIndex: F,
        disabledIndices: E
      })) : f ? v.current = F <= C ? d && F !== -1 ? i.current.length : B : oe(i, {
        startingIndex: F,
        decrement: !0,
        disabledIndices: E
      }) : v.current = Math.max(C, oe(i, {
        startingIndex: F,
        decrement: !0,
        disabledIndices: E
      })), Xe(i, v.current) && (v.current = -1), R();
    }
  }), ne = p.useMemo(() => g && n && U && {
    "aria-activedescendant": k || we
  }, [g, n, U, k, we]), re = p.useMemo(() => ({
    "aria-orientation": I === "both" ? void 0 : I,
    ...W ? {} : ne,
    onKeyDown: se,
    onPointerMove() {
      $.current = !0;
    }
  }), [ne, se, I, W]), be = p.useMemo(() => {
    function T(C) {
      x === "auto" && ir(C.nativeEvent) && (L.current = !0);
    }
    function F(C) {
      L.current = x, x === "auto" && sr(C.nativeEvent) && (L.current = !0);
    }
    return {
      ...ne,
      onKeyDown(C) {
        $.current = !1;
        const B = C.key.startsWith("Arrow"), q = ["Home", "End"].includes(C.key), Z = B || q, je = $n(C.key, I, h), st = Bn(C.key, I, h, S), Ge = $n(C.key, V(), h), me = mt(C.key, I), De = (m ? Ge : me) || C.key === "Enter" || C.key.trim() === "";
        if (g && n) {
          const lt = y?.nodesRef.current.find((ut) => ut.parentId == null), Ie = y && lt ? so(y.nodesRef.current, lt.id) : null;
          if (Z && Ie && P) {
            const ut = new KeyboardEvent("keydown", {
              key: C.key,
              bubbles: !0
            });
            if (je || st) {
              var ct, cn;
              const Er = ((ct = Ie.context) == null ? void 0 : ct.elements.domReference) === C.currentTarget, un = st && !Er ? (cn = Ie.context) == null ? void 0 : cn.elements.domReference : je ? i.current.find((an) => an?.id === we) : null;
              un && (ce(C), un.dispatchEvent(ut), _(void 0));
            }
            if ((me || q) && Ie.context && Ie.context.open && Ie.parentId && C.currentTarget !== Ie.context.elements.domReference) {
              var ln;
              ce(C), (ln = Ie.context.elements.domReference) == null || ln.dispatchEvent(ut);
              return;
            }
          }
          return se(C);
        }
        if (!(!n && !w && B)) {
          if (De) {
            const lt = mt(C.key, V());
            M.current = m && lt ? null : C.key;
          }
          if (m) {
            Ge && (ce(C), n ? (v.current = Kt(i, ee.current), R()) : r(!0, C.nativeEvent, "list-navigation"));
            return;
          }
          me && (u != null && (v.current = u), ce(C), !n && w ? r(!0, C.nativeEvent, "list-navigation") : se(C), n && R());
        }
      },
      onFocus() {
        n && !g && (v.current = -1, R());
      },
      onPointerDown: F,
      onPointerEnter: F,
      onMouseDown: T,
      onClick: T
    };
  }, [we, ne, S, se, ee, x, i, m, R, r, n, w, I, V, h, u, y, g, P]);
  return p.useMemo(() => l ? {
    reference: be,
    floating: re,
    item: G
  } : {}, [l, be, re, G]);
}
const yi = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function $i(e, t) {
  var n, r;
  t === void 0 && (t = {});
  const {
    open: o,
    elements: s,
    floatingId: i
  } = e, {
    enabled: c = !0,
    role: a = "dialog"
  } = t, l = Nt(), u = ((n = s.domReference) == null ? void 0 : n.id) || l, d = p.useMemo(() => {
    var w;
    return ((w = Ct(s.floating)) == null ? void 0 : w.id) || i;
  }, [s.floating, i]), f = (r = yi.get(a)) != null ? r : a, h = ot() != null, g = p.useMemo(() => f === "tooltip" || a === "label" ? {
    ["aria-" + (a === "label" ? "labelledby" : "describedby")]: o ? d : void 0
  } : {
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": f === "alertdialog" ? "dialog" : f,
    "aria-controls": o ? d : void 0,
    ...f === "listbox" && {
      role: "combobox"
    },
    ...f === "menu" && {
      id: u
    },
    ...f === "menu" && h && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [f, d, h, o, u, a]), x = p.useMemo(() => {
    const w = {
      id: d,
      ...f && {
        role: f
      }
    };
    return f === "tooltip" || a === "label" ? w : {
      ...w,
      ...f === "menu" && {
        "aria-labelledby": u
      }
    };
  }, [f, d, u, a]), b = p.useCallback((w) => {
    let {
      active: E,
      selected: I
    } = w;
    const O = {
      role: "option",
      ...E && {
        id: d + "-fui-option"
      }
    };
    switch (a) {
      case "select":
      case "combobox":
        return {
          ...O,
          "aria-selected": I
        };
    }
    return {};
  }, [d, a]);
  return p.useMemo(() => c ? {
    reference: g,
    floating: x,
    item: b
  } : {}, [c, g, x, b]);
}
export {
  ki as F,
  Ei as a,
  Si as b,
  Ni as c,
  $i as d,
  _i as e,
  Ti as f,
  Fi as g,
  Di as h,
  Pi as i,
  Oi as j,
  Mi as k,
  Li as l,
  Vi as m,
  Ai as n,
  Ii as o,
  Go as p,
  Ci as s,
  Wi as u
};
//# sourceMappingURL=floating-ui.react-87bo4V3_.js.map
